import React, { memo } from 'react'
import styled from 'styled-components'
import Anime from '../Animation/Anime'
import {
  timelineShow,
  timelineHide,
  fadeIn,
  fadeOut,
  custom,
  easings,
} from '../Animation/Animations'
import { transparentUI } from '../../style-functions'

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100vh;
  color: white;
`

const Timeline = styled.div`
  position: absolute;
  z-index: 2000;
  width: 100%;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  ${transparentUI}
`

const Map = styled.div`
  position: absolute;
`

const Legend = styled.div`
  position: absolute;
  z-index: 5;
  right: 5rem;
  bottom: 28rem;
`

const Topic = styled.div`
  position: absolute;
  z-index: 5;
  left: 5rem;
  bottom: 28rem;
`

const Intro = styled.div`
  position: absolute;
  z-index: 7000;
  width: 100%;
  height: 100%;
`

const introAnimation = { duration: 2000, easing: easings.EASE_OUT_EXPO }
const up = { opacity: [0, 1], translateY: [20, 0] }
const down = { opacity: [1, 0], translateY: [0, 20] }

// {({ add, done }) =>
//       add(
//         <Anime
//           in={done && isVisible}
//           appear={true}
//           enter={fadeIn({ targets: TARGET_CHILDREN, delay: stagger(300) })}
//           exit={fadeOut({
//             targets: TARGET_CHILDREN,
//             delay: staggerReverse(300),
//             duration: 500,
//           })}
//           protectChildren={true}
//         ></Anime>

const Layout = ({ timeline, map, legend, topic, intro, active }) => (
  <Wrapper>
    <Map>{map}</Map>
    <Anime in={active} enter={timelineShow} exit={timelineHide}>
      <Timeline> {timeline}</Timeline>
    </Anime>
    <Topic>
      <Anime in={active}>{topic}</Anime>
    </Topic>
    <Anime
      in={active}
      enter={fadeIn({ delay: 1000, duration: 300 })}
      exit={fadeOut({ duration: 200 })}
    >
      <Legend>{legend}</Legend>
    </Anime>
    <Anime
      in={!active}
      enter={custom({
        ...introAnimation,
        ...up,
        delay: 2000,
      })}
      exit={custom({
        ...introAnimation,
        ...down,
      })}
      container={Intro}
    >
      {intro}
    </Anime>
  </Wrapper>
)

export default memo(Layout)
